var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyMemberListDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 52.922,
    viewBox: "0 0 100 52.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29732",
    "data-name": "Group 29732",
    transform: "translate(-1597 -383)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "group",
    d: "M40.749,46.451c5.844,0,11.594-9.5,11.594-19.172,0-10.094-6.312-12.219-11.594-12.219-5.312,0-11.594,2.125-11.594,12.219C29.156,36.951,34.89,46.451,40.749,46.451Zm19.438,7.2a51.056,51.056,0,0,1-8.453-3.625c-1.5-.812-3.094-1.7-4.7-2.672a9.708,9.708,0,0,1-12.578,0c-1.25.766-2.875,1.719-4.719,2.672-.859.453-1.688.859-2.469,1.234A44.7,44.7,0,0,1,21.3,53.654c-6.469,2.016-8.109,10.672-8.5,14.328H68.687C68.281,64.341,66.671,55.685,60.187,53.654Z",
    transform: "translate(1606.266 367.94)",
    fill: "#a49dc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "group-2",
    "data-name": "group",
    d: "M17.047,40.452a5.25,5.25,0,0,0,3.406,1.484,5.346,5.346,0,0,0,3.484-1.531L24,40.343C26.687,37.89,28.734,32.984,28.734,28c0-7.219-4.5-8.734-8.281-8.734-3.766,0-8.266,1.516-8.266,8.734,0,4.969,2.031,9.875,4.7,12.328A1.367,1.367,0,0,1,17.047,40.452Zm12.563,7.078c.609-.172,1.266-.406,1.922-.656-.937-.422-1.937-.906-3.031-1.453-1.281-.656-2.406-1.328-3.313-1.875A8.018,8.018,0,0,1,20.469,45.2a7.914,7.914,0,0,1-4.719-1.656c-.844.516-1.984,1.187-3.328,1.875a37.5,37.5,0,0,1-6.375,2.734C1.656,49.515.375,55.2,0,58.078H20.219C21.625,53.781,24.344,49.156,29.609,47.531Z",
    transform: "translate(1597 370.985)",
    fill: "#6a5fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "group-3",
    "data-name": "group",
    d: "M50.777,41.946a5.218,5.218,0,0,0,3.406-1.484c.047-.031.078-.078.125-.109,2.672-2.453,4.719-7.359,4.719-12.344,0-7.219-4.5-8.734-8.266-8.734-3.781,0-8.281,1.516-8.281,8.734,0,5,2.078,9.938,4.766,12.375A5.57,5.57,0,0,0,50.777,41.946ZM65.23,48.133A38.764,38.764,0,0,1,58.824,45.4c-1.281-.672-2.422-1.344-3.312-1.875a8.055,8.055,0,0,1-4.719,1.656,7.923,7.923,0,0,1-4.734-1.656c-1.109.672-2.219,1.313-3.312,1.875-1.062.563-2.078,1.047-3.016,1.453.672.266,1.313.469,1.922.656,5.25,1.641,7.969,6.266,9.375,10.547h20.2C70.871,55.2,69.589,49.508,65.23,48.133Z",
    transform: "translate(1625.77 370.992)",
    fill: "#6a5fa2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMemberListDark);
export default __webpack_public_path__ + "static/media/empty-member-list-dark.cbaf7d4accf8e704eb1a1517e2be9348.svg";
export { ForwardRef as ReactComponent };